import axios from "axios";
import { getAuth } from "firebase/auth";

const api = axios.create({
  baseURL: "/.netlify/functions/api"
});

api.interceptors.request.use(
  async (config) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      const token = await user.getIdToken(true);
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
